import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import { persistor, store } from './store/store';

import './config/i18n/i18n';
import { SnackbarProvider } from 'notistack';
import { injectStore } from 'shared/api/interceptors';
import { LicenseInfo } from '@mui/x-license-pro';
import { SnackbarUtilsConfigurator } from 'shared/utils/toast';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_X_PREMIUM_LICENSE_KEY);
injectStore(store);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <SnackbarProvider
      maxSnack={3}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right'
      }}>
      <SnackbarUtilsConfigurator />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Router>
            <Routes>
              <Route path="/*" element={<App />} />
            </Routes>
          </Router>
        </PersistGate>
      </Provider>
    </SnackbarProvider>
  </React.StrictMode>
);
